"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _string_utility = require("../../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _click_or_escape_outside = require("../click_or_escape_outside");

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _dropdown_component = require("./dropdown_component");

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateRangeDropdown = function (_Component) {
  _inherits(DateRangeDropdown, _Component);

  function DateRangeDropdown() {
    _classCallCheck(this, DateRangeDropdown);

    var _this = _possibleConstructorReturn(this, (DateRangeDropdown.__proto__ || Object.getPrototypeOf(DateRangeDropdown)).call(this));

    _this.renderDateRangeComponent = _this.renderDateRangeComponent.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    return _this;
  }

  _createClass(DateRangeDropdown, [{
    key: "onClose",
    value: function onClose() {
      this.childRef.focus();
    }
  }, {
    key: "renderDateRangeComponent",
    value: function renderDateRangeComponent() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        {
          className: "" + _functional_utility2.default.isTabOrMobileBreakpoint(this.props.parentProps.breakpoint, "width-percent-100", "display-inline-block margin-top-0 width-percent-20 text-top margin-right-10 " + ((0, _ramda.isNil)(this.props.additionalClassName) ? "" : this.props.additionalClassName)) },
        _react2.default.createElement(
          "label",
          {
            className: this.props.isRegularSavingsAndDesktop ? 'margin-bottom-20 tag-2 display-block' : 'margin-bottom-5 tag-2 display-block', id: "DateRange", htmlFor: "dateRangeFilter" },
          _string_utility2.default.renderFormattedLabel("DATE RANGE", "pdp-perf-chart-date-range-label")
        ),
        _react2.default.createElement(
          "div",
          {
            className: "" + _functional_utility2.default.isTabOrMobileBreakpoint(this.props.parentProps.breakpoint, "selectParent-bp2", "selectParent") },
          _react2.default.createElement(
            _click_or_escape_outside2.default,
            { id: "date-selector", onClose: this.onClose },
            _react2.default.createElement(_dropdown_component2.default, {
              dropdownContent: this.props.dateRangeItems(),
              id: "dateRangeFilter",
              className: "disclaimer width-percent-100",
              breakpoint: this.props.parentProps.breakpoint,
              initialActiveSelect: this.props.state.selectedDateOption,
              initialActiveSelectTranslationKey: this.props.state.selectedDateOptionTranslateKey,
              alwaysOpenOnSelect: false,
              refSuffix: "dateRange",
              setRef: this.props.setRef('dropdown-label-dateRange'),
              ariaLabelledby: "DateRange",
              setRefDropdown: function setRefDropdown(node) {
                return _this2.childRef = node;
              }
            })
          )
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { "data-testid": "date-range-component", className: "display-inline" },
        this.renderDateRangeComponent()
      );
    }
  }]);

  return DateRangeDropdown;
}(_react.Component);

exports.default = DateRangeDropdown;